//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProductImageViewer from "~/frontend/components/common/product-image-viewer.vue";
import {productDetailAttributeCodes} from "~/frontend/enums/productDetailAttributeCodes"
import {columnFormatterMixin} from "@/mixins/columnFormatterMixin";
import {mapActions} from "vuex";
import {getShoppingCartSID} from "@/utils/helpers";

export default {
  name: "product.vue",
  components: {ProductImageViewer},
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  mixins:[columnFormatterMixin],
  data() {
    return {
      product: {},
      panels:[],
      productDetailAttributeCodes,
      hasChildrenItemTypes: true,
      relatedProducts:[],
      productDetailAttr: null,
      metalAttr: null,
      provideFingerPrintAttr: null,
      materialAttr: null,
      dialog: false,
      formLoading: false,
      firstLoad: true,
    }
  },
  async mounted(){
    this.firstLoad = true;
    const sku = this.$route.params.pathMatch.split('/').pop()
    this.product = await this.$axios.$get(`/itemtypes/getbysku/${sku}`,{params: {
        includeattributes: true,
        includesubitems: true,
        customerID: this.$auth.loggedIn ? this.$auth.user?.customerId : null
      }} )

    const relatedProductResponse =  await this.$axios.$get(`/productcategories/${sku}/related-products`);
    this.relatedProducts = relatedProductResponse?.value ?? [];

    this.hasChildrenItemTypes = await this.getMasterItemTypeHasChildren();

    this.initAttributesForExpansionPanels()
    this.firstLoad = false;
  },
  methods: {
    ...mapActions('shoppingCart', ['addToCart']),
    async getMasterItemTypeHasChildren(){
      const response = await this.$axios.$get(`itemtypes/${this.product.id}/has-children`);
      return response.value ?? false;
    },
    initAttributesForExpansionPanels(){
      this.customAttributes.forEach( c => {
        if(c.showInProductCatalog && c.value !== null && c.value !== ''){
          switch (c.code){
            case this.productDetailAttributeCodes.PRODUCT_DETAILS:
              this.productDetailAttr = c;
              break;
            case this.productDetailAttributeCodes.METALS:
              this.metalAttr = c;
              break;
            case this.productDetailAttributeCodes.PROVIDE_FINGERPRINT_OR_GRAPHIC:
              this.provideFingerPrintAttr = c;
              break;
            case this.productDetailAttributeCodes.MATERIAL:
              this.materialAttr = c;
              break;
          }

        }
      })
    },
    goToConfigurator(skip = false){
      if(this.$auth.loggedIn === false && skip === false){
        this.dialog = true;
        return;
      }
      this.$router.push(`/product/${this.product.code}${this.configuratorUrl}`)
    },
    async addItemToCart(skip = false){
      if(this.$auth.loggedIn === false && skip === false){
        this.dialog = true;
        return;
      }
      this.formLoading = true;

      const shoppingCartItem = this.prepareShoppingCartItem();

      const addToCartResult = await this.addToCart({shoppingCartItem: shoppingCartItem, path: this.shoppingCartUrl})

      if (addToCartResult.hasErrors === false && this.$auth.loggedIn) {
        this.$router.push(this.shoppingCartUrl)
      }
      else if (addToCartResult.hasErrors === false && this.$auth.loggedIn === false){
        this.$router.push(this.signInLink + "?redirectBackTo=" + this.shoppingCartUrl)
      }
      this.formLoading = false;
    },
    prepareShoppingCartItem() {
      const shoppingCartItem = {
        ItemTypeID: this.product.id,
        Quantity: 1,
        Notes: '',
        Name: this.product.name,
        sessionID: getShoppingCartSID(),
      }

      shoppingCartItem.ItemTypeData = {
        ItemTypeID: this.product.id,
        itemTypeName: this.product.name,
        Quantity: 1,
        Price: this.product.price ? this.product.price : 0,
        Attributes: this.product.customAttributes,
        Subitems: this.product.subItems,
        ImageUrl: this.product.productImageURLs[0] || '',
      }
      return shoppingCartItem
    },
  },
  computed:{
    backgroundColor(){
      return this.section?.product_background_color?.fieldValue.value ?? "";
    },
    textColor(){
      return this.section?.product_text_color?.fieldValue.value ?? "";
    },
    titleTextColor(){
      return this.section?.product_title_text_color?.fieldValue.value ?? "";
    },
    lightColor(){
      return this.section?.product_light_color?.fieldValue.value ?? "";
    },
    configuratorUrl(){
      return this.section?.product_configurator_url?.fieldValue.value ?? "/configurator";
    },
    notSignedInMessage(){
      return this.section?.not_signed_in_message?.fieldValue.value ?? "";
    },
    shoppingCartUrl(){
      return this.section?.shopping_cart_url?.fieldValue.value ?? "/shopping-cart";
    },
    signInLink(){
      return this.section?.sign_in_url?.fieldValue.value ?? "/nmd-sign-in";
    },
    customAttributes(){
      return this.product?.customAttributes ?? [];
    }
  }
}
